import canUseDOM from "dom-helpers/canUseDOM";
import { useLayoutEffect, useEffect } from "react";
const useIsomorphicEffect = canUseDOM ? useLayoutEffect : useEffect;
export default useIsomorphicEffect;
